import { ProductItem } from "../types";

export class SearchProductClickEvent extends Event {
    static NAME = "search:product-click";

    constructor(
        readonly details: {
            item: ProductItem;
            position: number;
        }
    ) {
        super(SearchProductClickEvent.NAME, {
            bubbles: true,
            cancelable: false,
        });
    }
}
